class TpsrService {
    static $inject = ["$q", "clientDataService", "dataService"];

    constructor($q, clientDataService, dataService) {
        this.$q = $q;
        this.clientData = clientDataService;
        this.data = dataService;
        this.user = null;
        this.customer = null;
    }

    login = (username, password) => {
        return this.data.login(username, password)
            .then(loginResult => {
                if (loginResult.logged_in) {
                    this.clientData.setToken(loginResult.token);
                    return this.getSession().then(() => loginResult);
                }
                else
                    return loginResult;
            });
    };

    logout = () => {
        return this.data.logout()
            .then(() => {
                this.clientData.removeToken();
                this._logout();
            });;
    };

    getSession = () => {
        return this.data.getSession()
            .then(session => {
                if (session) {

                    if (!this.user || this.user.user_id !== session.user.user_id) {
                        this.user = session.user;
                        this.user.full_name = session.user.first_name + " " + session.user.last_name;
                    }

                } else {
                    this._logout();
                }
                return session;
            })
            .catch(() => {
                this._logout();
            });
    }

    _logout = () => {
        this.user = null;
    };

    isLoggedIn = () => {
        return this.user ? true : false;
    }

    getUserForCreatePassword = key => {
        return this.data.getUserForCreatePassword(key);
    };

    updateUserPasswordFromKey = (key, password) => {
        return this.data.updateUserPasswordFromKey(key, password)
            .then(result => {
                if (result.is_valid) {
                    this.clientData.setToken(result.token);
                    return this.getSession().then(() => result);
                }
                else
                    return result;
            });
    };

    resetPasswordRequest = request => {
        return this.data.resetPasswordRequest(request);
    };

    createUserEmailRequest = request => {
        return this.data.createUserEmailRequest(request);
    };


    getCustomers = () => {
        return this.data.getCustomers();
    };

    getCustomer = PIMS_customer_id => {
        return this.data.getCustomer(PIMS_customer_id).then(c => {
            this.customer = c;
            return c;
        });;
    };

    insertUser = request => {
        return this.data.insertUser(request);
    };

    updateUser = request => {
        return this.data.updateUser(request);
    };

    // page_size, page_number, order_by, order_descending, user_id, email, emp_id, is_npc_admin, is_manager, PIMS_customer_id, manager_id
    getNpcAdmins = (page_size, page_number, order_by, order_descending) => {
        return this.data.searchUsers(page_size, page_number, order_by, order_descending, null, null, null, true, null, null, null);
    };

    // page_size, page_number, order_by, order_descending, user_id, email, emp_id, is_npc_admin, is_manager, PIMS_customer_id, manager_id, include_disabled
    getUsers = (page_size, page_number, order_by, order_descending, PIMS_customer_id, manager_id, include_disabled) => {
        return this.data.searchUsers(page_size, page_number, order_by, order_descending, null, null, null, false, null, PIMS_customer_id, manager_id, include_disabled);
    };

    // page_size, page_number, order_by, order_descending, user_id, email, emp_id, is_npc_admin, is_manager, PIMS_customer_id, manager_id
    getManagers = PIMS_customer_id => {
        return this.data.searchUsers(100, 1, "user_id", false, null, null, null, false, true, PIMS_customer_id, null);
    };

    // page_size, page_number, order_by, order_descending, user_id, email, emp_id, is_npc_admin, is_manager, PIMS_customer_id, manager_id
    getUserforEmpId = (PIMS_customer_id, emp_id) => {
        return this.data.searchUsers(100, 1, "user_id", false, null, null, emp_id, null, null, PIMS_customer_id, null);
    };

    // page_size, page_number, order_by, order_descending, user_id, email, emp_id, is_npc_admin, is_manager, PIMS_customer_id, manager_id
    getUserforEmail = (email) => {
        return this.data.searchUsers(100, 1, "user_id", false, null, email, null, null, null, null, null);
    };

    getUser = user_id => {
        return this.data.getUser(user_id).then(user => {
            user.full_name = user.first_name + " " + user.last_name;
            return user;
        })
    };

    getStatesAndCitiesForZipcode = zip_code => {
        return this.data.getStatesAndCitiesForZipcode(zip_code);
    };

    userToggleRole = (user_id, prop_name, value) => {
        return this.data.userToggleRole(user_id, prop_name, value);
    };


    getItems = PIMS_customer_id => {
        return this.data.getItems(PIMS_customer_id);
    };

    updateMultipleItems = request => {
        return this.data.updateMultipleItems(request);
    };

    getOrdersUser = (page_size, page_number, order_by, order_descending, user_id) => {
        return this.data.getOrdersUser(page_size, page_number, order_by, order_descending, user_id);
    };

    getOrdersPending = (page_size, page_number, order_by, order_descending, manager_id) => {
        return this.data.getOrdersPending(page_size, page_number, order_by, order_descending, manager_id);
    };

    getOrder = order_id => {
        return this.data.getOrder(order_id);
    };

    deleteOrder = order_id => {
        return this.data.deleteOrder(order_id);
    };

    approveOrder = order_id => {
        return this.data.approveOrder(order_id);
    };

    rejectOrder = order_id => {
        return this.data.rejectOrder(order_id);
    };

    publicApproveOrder = (order_id, user_id) => {
        return this.data.publicApproveOrder(order_id, user_id);
    };

    publicRejectOrder = (order_id, user_id) => {
        return this.data.publicRejectOrder(order_id, user_id);
    };

    createOrder = request => {
        return this.data.createOrder(request);
    };

    createReturn = request => {
        return this.data.createReturn(request);
    };

    getReturns = (order_id, user_id) => {
        return this.data.getReturns(order_id, user_id);
    };

    getShippingLabel = return_id => {
        return this.data.getShippingLabel(return_id);
    };

    getPublicOrderLink = link_id => {
        return this.data.getPublicOrderLink(link_id);
    };
}

angular
    .module("app")
    .service("tpsrService", TpsrService);
